import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, Link, useParams } from 'react-router-dom';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import '../styles/style.css';
import MainSidebar from '../components/MainSidebar';
import dropdownvertical from '../assets/images/drop_vertical.svg';
import search_icon from '../assets/images/search_icon.svg';
import verified from '../assets/images/verified.svg';
import back_btn from '../assets/images/back_btn.svg';
import subscrption_count from '../assets/images/Subscriptions.svg';
import image_icon from '../assets/images/image_upload.svg';
import video_icon from '../assets/images/Video.svg';
import heart_icon from '../assets/images/heart_icon.svg';
import whitedrop_down from '../assets/images/whitedrop_down.svg';
import Settings_blue from '../assets/images/Settings_blue.svg';
import Shere_blue from '../assets/images/Shere.svg';
import default_header_image from '../assets/images/default_header_image.png';
import blue_star from '../assets/images/blue_star.svg';
import default_user from '../assets/images/default_user.webp';
import downarrow from '../assets/images/Down.svg';
import fbicon from '../assets/images/Facebook.svg';
import twittericon from '../assets/images/Twitter.svg';
import instaicon from '../assets/images/Instagram.svg';
import youtubeicon from '../assets/images/YouTube.svg';
import snapicon from '../assets/images/snapchat.svg'; 
import fullviewlist from '../assets/images/FullView.svg'; 
import compactviewlist from '../assets/images/CompactView.svg'; 
import chat_icon from '../assets/images/Messages.svg'; 
import HomeSidebarFooterLinks from '../components/HomeSidebarFooterLinks';
import SidebarSearch from '../components/SidebarSearch';
import UserHeaderDropdown from '../components/UserHeaderDropdown';
import TipButtonUserProfile from '../components/TipButtonUserProfile';
import UserProfilePostsCompact from '../components/UserProfilePostsCompact';
import AddToListLinkUserProfile from '../components/AddToListLinkUserProfile';
import FilterDropdownUserProfile from '../components/FilterDropdownUserProfile';
import UsersProfilePostsCompact from '../components/UsersProfilePostsCompact';
import UsersProfileOnlyPostsCompact from '../components/UsersProfileOnlyPostsCompact';
import UserProfilePosts from '../components/UserProfilePosts';
import Subscription from '../components/Subscription';
import UserPosts from '../components/UserPosts';
import info_icon from '../assets/images/info.svg';
import config from '../config/config';
const UserProfile = () => {
  const [userData, setUserData] = useState({
    phone: '',
    user_name: '',
    user_id: '',
    name: '',
    activity_status: '',
    online_status: '',
    subs_type: '',
    role: '',
    is_user_post_hidden:'', 
    subscriptions: []
  });
  const [loading, setLoading] = useState(true);
  const [copySuccess, setCopySuccess] = useState('');
  const navigate = useNavigate();
  const { user_name } = useParams();
  const [userId, setUserId] = useState(null);
  const [totalPosts, setTotalPosts] = React.useState(0);
  const [totalMediaPosts, setTotalMediaPosts] = React.useState(0);
  const [totalImages, setTotalImages] = React.useState(0);
  const [totalVideos, setTotalVideos] = React.useState(0);
  const [totalLikes, setTotalLikes] = React.useState(0);
  const [isExpanded, setIsExpanded] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [showToast, setShowToast] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [isCompactView, setIsCompactView] = useState(false);
  const toastRef = useRef(null);
  const [posts, setPosts] = useState([]);
  const [filter, setFilter] = useState('all');
  const [isListView, setIsListView] = useState(false);


useEffect(() => {
  const token = localStorage.getItem('token');
  if (!token) {
    navigate('/Login');
    return;
  }

  const fetchUserDetails = async () => {
    try {
      // Fetch the current authenticated user's details
      const currentUserResponse = await axios.get(`${config.baseURL}/current-user-details`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const currentUser = currentUserResponse.data.data.user; 


      // Fetch the profile details for the requested username
      const userDetailsResponse = await axios.get(`${config.baseURL}/user-details/${user_name}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const userDetails = userDetailsResponse.data.data.user_details;
      const user = userDetailsResponse.data.data.user;
      const subscriptions = userDetailsResponse.data.data.subscriptions;

      // Redirect if the profile belongs to the currently authenticated user
      if (user.user_name.toLowerCase() === currentUser.user_name.toLowerCase()) {
        navigate('/myprofile', { replace: true });
        return;
      }
      setUserData({
        ...userDetails,
        user_id: user.id,
        name: user.name,
        user_name: user.user_name,
        activity_status: userDetails.activity_status,
        bio: userDetails.bio,
        role: user.role,
        profile: userDetails.user_profile,
        subs_type: user.subs_type,
        subscriptions: subscriptions || [],
        is_subscribed: user.is_subscribed,
        is_user_post_hidden: user.is_user_post_hidden,
        wallet_balance: currentUser.wallet_balance
      });
      setUserId(user.id);

    }  catch (error) {
      console.error('Error fetching user details', error.response ? error.response.data : error.message);
      // Handle 404 or other errors appropriately
      if (error.response?.status === 404) {
        navigate('/not-found', { replace: true });
      }
    } finally {
      setLoading(false);
    }
  };

  fetchUserDetails();
}, [user_name, navigate]);



  const handleBackClick = () => {
    navigate(-1); // Go back to the previous page
  };


  const divStyle = {
    display: userData.role === 'user' ? 'none' : 'inline-block',
  };

  const handlePostCountChange = (totalPosts, totalMediaPosts, totalImages, totalVideos, totalLikes) => {
    setTotalPosts(totalPosts);
    setTotalMediaPosts(totalMediaPosts);
    setTotalImages(totalImages);
    setTotalVideos(totalVideos);
    setTotalLikes(totalLikes);
  };

  const toggleBio = () => {
    setIsExpanded(!isExpanded);
  };

  const WORD_LIMIT = 15;

  const exceedsWordLimit = (text) => {
    return text.split(' ').length > WORD_LIMIT;
  };

    // Copy Profile Link Function
 const copyProfileLink = async () => {
    const profileUrl = `${window.location.origin}/${userData.user_name}`;

    try {
      await navigator.clipboard.writeText(profileUrl);
      setToastMessage('Profile link copied to clipboard!');
      setShowToast(true);

      // Remove the 'hide-message' class if it's present
      if (toastRef.current) {
        toastRef.current.classList.remove('hide-message');
      }

      // Set a timeout to add the 'hide-message' class after 2 seconds
      setTimeout(() => {
        if (toastRef.current) {
          toastRef.current.classList.add('hide-message');
        }
      }, 3000); // Hide after 3 seconds

    } catch (error) {
      setErrorMessage('Error copying link');
    }
  };

  const isMediaTabDisabled = totalMediaPosts === 0; 

  const handleViewToggle = () => {
    setIsCompactView((prev) => !prev);
  };

  const handleViewToggleMedia = () => {
    setIsListView((prev) => !prev);
  };

  const getInitials = (name) => {
    if (!name || typeof name !== 'string' || name.trim() === '') {
      return ''; // Return an empty string or a default fallback if name is invalid
    }

    const nameParts = name.trim().split(' ');
    if (nameParts.length === 1) {
      return nameParts[0][0].toUpperCase();
    }

    return (nameParts[0][0] + nameParts[1][0]).toUpperCase();
  };

useEffect(() => {
  if (userData && userData.user_name) {
    const capitalizedUserName = userData.user_name.charAt(0).toUpperCase() + userData.user_name.slice(1);
    document.title = `${capitalizedUserName} - PatreonPass`;
  } else {
    document.title = 'PatreonPass';
  }
}, [userData]);


const isSubscribed = userData.is_subscribed;


  return (
    <div>
      <div className="main_patreonpass_wrapper user_profile_page"> 
          <div className="patreonpass_container">
            <div className="left_sidebar">
              <MainSidebar />
            </div>
            <div
              className={`patreonpass_main_content ${userData.role === 'user' ? 'remove_sider_user' : ''}`}
              id="content"
            >
               <div className="left_main_content">
                      <div className="middlw_wrap">
                        <div className="b_profile_wrapper">
                          <div className="b_profile_header user_profile_head">
                            <div className="profile_head">
                              <div className="profile_head_left">
                                <div className="head_profile_content">
                                  <div className="head_profile_content_left">
                                    <button className="profile_back_btn" onClick={handleBackClick}>
                                      <img src={back_btn} alt="" />
                                    </button>
                                  </div>
                                  <div className="head_profile_content_left">
                                    <div className="profile_name_head">{userData.name}
                                        <svg style={divStyle} class="home_sidebar_user_verify head_section" width="16" height="16" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M61.6076 13.7848L56.9968 6.10012C56.9652 6.04751 56.8964 6.03362 56.849 6.07253C52.6506 9.51474 42.1011 14.213 32.6436 6.08581C32.594 6.04321 32.5175 6.05367 32.4878 6.11189C30.1809 10.6355 22.8439 19.7553 11.3791 21.0382C11.3194 21.0449 11.2772 21.0993 11.2905 21.1579C12.475 26.3811 12.658 38.0206 4.1023 43.8173C4.05005 43.8527 4.03933 43.9254 4.08371 43.9702C8.22706 48.1592 15.3163 58.6835 11.3288 68.1314C11.3002 68.1992 11.3472 68.2756 11.4207 68.274C16.3178 68.1652 26.8065 70.985 30.9447 83.2021C30.9659 83.2648 31.039 83.2941 31.0941 83.2573C35.9852 79.9892 47.7732 75.534 56.8267 83.2349C56.8796 83.2799 56.9615 83.2638 56.9867 83.1991C58.9473 78.1609 65.5991 68.3556 77.0421 68.2789C77.1088 68.2785 77.1593 68.2175 77.1409 68.1533C75.4455 62.2367 74.8734 49.3511 85.8645 43.952C85.9282 43.9207 85.9427 43.834 85.8903 43.7863L80.2911 38.6962" stroke="#fefefe" stroke-width="6" stroke-linecap="round"></path><path d="M30.9874 39.2152L44.481 51.6709L81.3291 15.3418" stroke="#fefefe" stroke-width="6" stroke-linecap="round"></path></svg>
                                    </div>
                                    <div style={divStyle} className="profile_bottom_head my_profile_margin_remove">
                                      <ul className="list_below_name user_profile_top_menu">
                                        <li>
                                          <img src={image_icon} />
                                           <span> {totalImages} </span>
                                        </li>
                                        <li>
                                          <img src={video_icon} />
                                          <span> {totalVideos} </span>
                                        </li>
                                        <li>
                                          <img src={heart_icon} />
                                          <span> {totalLikes}</span>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="profile_head_right">
                                  <UserHeaderDropdown user={userData.user_name} isUserPostHidden={userData.is_user_post_hidden} userId={userData.user_id} /> 
                              </div>
                            </div>
                            <div className="img_wrap">
                              <img
                                src={userData.user_back_profile || default_header_image}
                                alt="Background"
                              />
                            </div>
                          </div>

                          <div className="b_profile_user_details">
                            <div className="b_profile_user_details_wrap">

                              <div className={`profile_avatar ${userData.activity_status === 'active' ? 'user_online_status' : ''}`}>
                                <Link to={`/${userData.user_name}`} className="profile_link">
                                  {userData.user_profile ? (
                                    <img
                                      src={userData.user_profile}
                                      alt="User Profile"
                                    />
                                  ) : (
                                    <span className="profile_name_none_image">
                                      {getInitials(userData.name)}
                                    </span>
                                  )}
                                </Link>
                              </div>

                              <div className="profile_head_right_icons">
                                <div className="btns_profile_blue btns_for_myprofile">
                                 
                                  {userData.is_subscribed && (
                                    <>
                                      <TipButtonUserProfile profile={userData.user_profile} user={userData.user_name} userId={userData.user_id} walletBalance={userData.wallet_balance} />
                                      <Link to={`/chatmessage/${userData.user_id}`}>
                                        <img className="chat_icon_profile" src={chat_icon} alt="" />
                                      </Link>
                                    </>
                                  )}
                                  
                                  <AddToListLinkUserProfile userId={userData.user_id} user={userData.user_name}  />

                                  <Link onClick={copyProfileLink}>
                                    <img src={Shere_blue} alt="" />
                                  </Link>
                                </div>
                              </div>
                            </div>
                            <div className="profile_social_wrap">
                              <div className="profile_social_wrap_head">
                                <div className="head_profile_content_left">
                                  <div className="profile_name_head">{userData.name}
                                  <img style={divStyle} className="user_profile_verify"  src={verified} />
                                  </div>
                                  <div className="profile_bottom_head my_profile_margin_remove">
                                    <ul className="list_below_name">
                                          <li>@{userData.user_name}</li>
                                          <li>
                                          {userData.activity_status === 'online'
                                            ? 'Available now'
                                            : userData.activity_status || 'Status not available'}
                                        </li>

                                    </ul>

                                  </div>                                  

                                  <div className="profile_social_wrap_middle middle_text_code">

                                    {userData.bio && exceedsWordLimit(userData.bio) ? (
                                      <>
                                        {isExpanded ? (
                                          <>
                                            <p>{userData.bio}</p>
                                            <Link className="more_text" onClick={toggleBio}>Collapse info</Link>
                                          </>
                                        ) : (
                                          <>
                                            <p className="bio-truncated">
                                              {userData.bio ? userData.bio.split(' ').slice(0, WORD_LIMIT).join(' ') + '...' : 'Bio not available'}
                                            </p>
                                            <Link className="more_text" onClick={toggleBio}>More info</Link>
                                          </>
                                        )}
                                      </>
                                    ) : (
                                      <p>{userData.bio}</p>
                                    )}
                                  </div>


                                  <div className="social_icons_profile">
                                    {userData.facebook_id && (
                                      <a href={userData.facebook_id} target="_blank" rel="noopener noreferrer">
                                        <img src={fbicon} alt="Facebook" /> Facebook
                                      </a>
                                    )}
                                    {userData.twitter_id && (
                                      <a href={userData.twitter_id} target="_blank" rel="noopener noreferrer">
                                        <img src={twittericon} alt="Twitter" /> Twitter
                                      </a>
                                    )}
                                    {userData.insta_id && (
                                      <a href={userData.insta_id} target="_blank" rel="noopener noreferrer">
                                        <img src={instaicon} alt="Instagram" /> Instagram
                                      </a>
                                    )}
                                    {userData.youtube_id && (
                                      <a href={userData.youtube_id} target="_blank" rel="noopener noreferrer">
                                        <img src={youtubeicon} alt="YouTube" /> YouTube
                                      </a>
                                    )}
                                    {userData.snap_id && (
                                      <a href={userData.snap_id} target="_blank" rel="noopener noreferrer">
                                        <img src={snapicon} alt="Snapchat" /> Snapchat
                                      </a>
                                    )}
                                  </div>


                                </div>
                              </div>
                              <div className="my_profile_gap" />
                            </div>
                          </div>
                        </div>
                         

                        {userData.subscription_offers_status === 'active' && (
                        <div className="middle_subscription_box" style={divStyle}>
                          <div className="subscription_wrapper">
                            <div className="subscription_head">SUBSCRIPTION</div>                            
                            <Subscription subsType={userData.subs_type} subscriptions={userData.subscriptions} user_name={user_name}  walletBalance={userData.wallet_balance}  />
                          </div>
                        </div>
)}

                        <div className="post_media_block">
                          <ul className="nav nav-tabs" id="myTab" role="tablist">
                            <li className="nav-item" role="presentation">
                              <button
                                className="nav-link active"
                                id="posts-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#posts"
                                type="button"
                                role="tab"
                                aria-controls="posts"
                                aria-selected="true"
                              >
                              {totalPosts > 0 ? `${totalPosts} Posts` : "No posts"}
                              </button>
                            </li>
                            <li className="nav-item" role="presentation">
                              <button
                                className={`nav-link ${isMediaTabDisabled || !isSubscribed ? 'disabled_tab' : ''}`}
                                id="media-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#media"
                                type="button"
                                role="tab"
                                aria-controls="media"
                                aria-selected="false"
                                tabIndex={-1}
                              >
                              {totalMediaPosts > 0 ? `${totalMediaPosts} Media` : "No Media"}
                              </button>
                            </li>
                          </ul>
                          {/* Tab Content */}
                          <div className="tab-content" id="myTabContent"> 
                            <div
                              className={`tab-pane fade show active ${!isSubscribed ? 'user_not_subscribed_this_user' : ''}`}
                              id="posts"
                              role="tabpanel"
                              aria-labelledby="posts-tab"
                            > 

                             {!isSubscribed && userData.role !== "user" && ( // Check for role type "user"
                              <div className="unlock_blog_post">
                                <div className="unlock_icon">
                                  <svg
                                    width={54}
                                    height={54}
                                    viewBox="0 0 54 54"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M36.6793 18.72V13.2C36.6793 8.11898 32.5603 4 27.4793 4C22.3983 4 18.2793 8.11898 18.2793 13.2V18.72"
                                      stroke="#8A96A3"
                                      strokeWidth="4.6"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                    <path
                                      d="M40.36 20.5601H14.6C12.0595 20.5601 10 22.6195 10 25.1601V45.4001C10 47.9406 12.0595 50.0001 14.6 50.0001H40.36C42.9005 50.0001 44.96 47.9406 44.96 45.4001V25.1601C44.96 22.6195 42.9005 20.5601 40.36 20.5601Z"
                                      stroke="#8A96A3"
                                      strokeWidth="4.6"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                    <path
                                      d="M27.4805 37.58V32.98"
                                      stroke="#8A96A3"
                                      strokeWidth="4.6"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </svg>                    
                                </div>
                                <div className="unlock_subscribe_btn">
                                  <div className="media_wrap_paid">
                                    <div className="media_count_left">
                                      <div className="media_count">
                                        <svg
                                          width={54}
                                          height={54}
                                          viewBox="0 0 54 54"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M14.3158 41.3006H41.1197C41.873 41.3006 42.2756 40.4134 41.7795 39.8464L34.4309 31.448C34.1088 31.0799 33.548 31.0465 33.1845 31.3736L25.6712 38.1356C25.3346 38.4385 24.8227 38.4353 24.4899 38.1281L20.0343 34.0153C19.6738 33.6824 19.1103 33.7103 18.7843 34.077L13.6605 39.8413C13.1578 40.4068 13.5593 41.3006 14.3158 41.3006Z"
                                            fill="#8A96A3"
                                          />
                                          <circle
                                            cx="3.94569"
                                            cy="3.94569"
                                            r="3.94569"
                                            transform="matrix(-1 0 0 1 23.7617 15.873)"
                                            fill="#8A96A3"
                                          />
                                          <path
                                            d="M48.314 7.98131V47.4382C48.314 47.9225 47.9215 48.315 47.4372 48.315H7.98034C7.49608 48.315 7.10352 47.9225 7.10352 47.4382V7.98131C7.10352 7.49706 7.49608 7.10449 7.98034 7.10449H47.4372C47.9215 7.10449 48.314 7.49706 48.314 7.98131Z"
                                            stroke="#8A96A3"
                                            strokeWidth="4.82251"
                                            strokeLinecap="round"
                                          />
                                        </svg>
                                        {totalImages}
                                      </div>
                                      <div className="video_count media_count">
                                        <svg
                                          width={54}
                                          height={54}
                                          viewBox="0 0 54 54"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M36.8627 10.4512H5.8904C4.84636 10.4512 4 11.2975 4 12.3416V40.5492C4 42.7583 5.79086 44.5492 7.99999 44.5492H36.8627C39.0719 44.5492 40.8627 42.7583 40.8627 40.5492V14.4512C40.8627 12.242 39.0719 10.4512 36.8627 10.4512Z"
                                            stroke="#8A96A3"
                                            strokeWidth={5}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          />
                                          <path
                                            d="M51.0005 15.52L40.8633 23.8141V30.7259L51.0005 39.9416V15.52Z"
                                            stroke="#8A96A3"
                                            strokeWidth={5}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          />
                                        </svg>
                                        {totalVideos} 
                                      </div>
                                    </div>
                                    <div className="post_price_right">
                                      <svg
                                        width={54}
                                        height={54}
                                        viewBox="0 0 54 54"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M36.6793 18.72V13.2C36.6793 8.11898 32.5603 4 27.4793 4C22.3983 4 18.2793 8.11898 18.2793 13.2V18.72"
                                          stroke="#8A96A3"
                                          strokeWidth="4.6"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                        <path
                                          d="M40.36 20.5601H14.6C12.0595 20.5601 10 22.6195 10 25.1601V45.4001C10 47.9406 12.0595 50.0001 14.6 50.0001H40.36C42.9005 50.0001 44.96 47.9406 44.96 45.4001V25.1601C44.96 22.6195 42.9005 20.5601 40.36 20.5601Z"
                                          stroke="#8A96A3"
                                          strokeWidth="4.6"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                        <path
                                          d="M27.4805 37.58V32.98"
                                          stroke="#8A96A3"
                                          strokeWidth="4.6"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                      </svg>
                                    </div>
                                  </div>
                                  <Link 
                                  className="user_btn_post_show" 
                                  onClick={(e) => {
                                    e.preventDefault(); // Prevent the default anchor behavior
                                    window.scrollTo({ top: 0, behavior: 'smooth' }); // Scroll to the top smoothly
                                  }}
                                > Subscribe to see user's Posts</Link>
                                </div>
                              </div>
                              )}
                              <div
                                  className="post_top_section_head collection_tabs_content"
                                >
                                <div className="title_post_head">RECENT</div>
                                <div className="title_post_head_shorting my_profile_shortings">
                                  <div className="list_type_view">                                      
                                      <div className="views_type">
                                        {isCompactView ? (
                                          <img
                                            src={fullviewlist}
                                            alt="Full View"
                                            style={{ cursor: 'pointer' }}
                                            onClick={handleViewToggle}
                                          />
                                        ) : (
                                          <img
                                            src={compactviewlist}
                                            alt="Compact View"
                                            style={{ cursor: 'pointer' }}
                                            onClick={handleViewToggle}
                                          />
                                        )}
                                      </div>
                                  </div>
                                  
                                </div>
                              </div>

                              {isCompactView ? (
                                <UsersProfileOnlyPostsCompact userId={userId} filter={filter} onPostCountChange={handlePostCountChange}  isCompactView={isCompactView}  />
                              ) : (
                                <UserProfilePosts userId={userId} filter={filter} onPostCountChange={handlePostCountChange}  isCompactView={isCompactView}  />
                              )}

                            </div>

                            <div
                              className="tab-pane fade"
                              id="media"
                              role="tabpanel"
                              aria-labelledby="media-tab"
                            >  

                            <div className="post_top_section_head collection_tabs_content" >
                                <div className="title_post_head">RECENT</div>
                                <div className="title_post_head_shorting my_profile_shortings">
                                  <div className="list_type_view">                                      
                                      <div className="views_type">
                                        {isListView ? (
                                          <img
                                            src={compactviewlist}
                                            alt="Compact View"
                                            style={{ cursor: 'pointer' }}
                                            onClick={handleViewToggleMedia}
                                          />
                                        ) : (
                                          
                                          <img
                                            src={fullviewlist}
                                            alt="Full View"
                                            style={{ cursor: 'pointer' }}
                                            onClick={handleViewToggleMedia}
                                          />
                                        )}
                                      </div>
                                  </div>
                              
                                </div>  
                              </div>

                              {isListView ? (
                                <UserProfilePosts userId={userId} filter={filter} onPostCountChange={handlePostCountChange}  isCompactView={isCompactView}  />                                
                              ) : (
                                <UsersProfilePostsCompact userId={userId} filter={filter} onPostCountChange={handlePostCountChange}  isCompactView={isCompactView}  />
                              )}

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>   



                   <div className="right_main_content" style={divStyle}>
                      <SidebarSearch />
                      {userData.subscription_offers_status === 'active' && (
                      <div className="subscription_wrapper">
                          <div className="subscription_head">SUBSCRIPTION</div>                          
                          <Subscription subsType={userData.subs_type} subscriptions={userData.subscriptions} user_name={user_name} />       
                        </div>
                      )}
                      <HomeSidebarFooterLinks />
                    </div>
                </div>

                <div className="share_text">
                {/* Conditionally render error message */}
                {errorMessage && (
                  <div className="error_message">{errorMessage}</div>
                )}
                {/* Conditionally render toast message */}
                {toastMessage && (
                  <div className="toast_message" ref={toastRef}>
                    {toastMessage}
                  </div>
                )}
              </div>


          </div>
        </div>
    </div>
  );
};

export default UserProfile;
